<template>
  <div class="timeline-item2" id="myComponent" style="background-color:  #fff; width: 100%;">
    <div
      class="timeTitle"
      style="font-weight: 700; color: #333; line-height: 36px; padding-left: 20px;"
    >跟单时间线</div>
    <div class="tabs" style="width: 96%;margin: 0 16px;" v-if="emtyTimes">
      <!-- 费用报销 -->
      <a-tabs ref="changeTime" @change="changeTime" type="card">
        <a-tab-pane
          key="0"
          class="tabpane3"
          :tab="`${this.$tree([], 'financialManage/expenseReim/index')}(${followData.reimbursementListCount ? followData.reimbursementListCount : 0})`"
          v-if="(followData.reimbursementListCount ? followData.reimbursementListCount : 0) && (this.$tree([], 'financialManage/expenseReim/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.reimbursementListCount ? followData.reimbursementListCount : 0"
            >
              <a-timeline-item
                class="timelineItem"
                v-for="item in reimbursementList"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="pound" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'financialManage/expenseReim/index') }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'financialManage/expenseReim/index'), 'financialManage/expenseReim/show.vue')"
                    >
                      {{
                      item.subject }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.reimbursementDate }})</span>&nbsp;&nbsp;
                    <span
                      class="clickable"
                      @click="openView(item, 'project')"
                    >{{ item.project }}</span>&nbsp;&nbsp;
                    <span v-if="item.amount !== '' && item.amount !== null">
                      ¥{{ parseFloat(item.amount).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <template>
                      <span>
                        <a-tag v-show="item.checkStatus === 3" color="red">未通过</a-tag>
                        <a-tag v-show="item.checkStatus === 2" color="green">通过</a-tag>
                        <a-tag v-show="item.checkStatus === 1" color="cyan">审核中</a-tag>
                        <a-tag v-show="item.checkStatus === 0" color="orange">未审核</a-tag>
                      </span>
                    </template>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.reimbursementListCount ? followData.reimbursementListCount : 0">-->
            <!--            &lt;!&ndash; <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> &ndash;&gt;-->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="1"
          class="tabpane3"
          :tab="`${this.$tree([], 'purchase/purchaseRequest/index')}(${followData.purchaseRequisitionListCount ? followData.purchaseRequisitionListCount : 0})`"
          v-if="(followData.purchaseRequisitionListCount ? followData.purchaseRequisitionListCount : 0) && (this.$tree([], 'purchase/purchaseRequest/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.purchaseRequisitionListCount ? followData.purchaseRequisitionListCount : 0"
            >
              <a-timeline-item
                v-for="item in purchaseRequisitionList"
                class="timelineItem"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'purchase/purchaseRequest/index') }}</span>
                  <span>
                    <a-tag color="orange" v-if="item.checkStatus === 0">未审核</a-tag>
                    <a-tag color="cyan" v-if="item.checkStatus === 1">审核中</a-tag>
                    <a-tag color="green" v-if="item.checkStatus === 2">审核通过</a-tag>
                    <a-tag color="red" v-if="item.checkStatus === 3">审核不通过</a-tag>
                    <a-tag color="orange" v-if="item.checkStatus === 4">待我审批</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'purchase/purchaseRequest/index'), 'purchase/purchaseRequest/show.vue')"
                    >
                      {{
                      item.title }}
                    </span>&nbsp;&nbsp;
                    <span>
                      <a-tag v-if="item.status === 0" color="red">待处理</a-tag>
                      <a-tag v-if="item.status === 1" color="orange">部分转采购</a-tag>
                      <a-tag v-if="item.status === 2" color="green">全部转采购</a-tag>
                      <a-tag v-if="item.status === 3" color="green">采购完成</a-tag>
                      <a-tag v-if="item.status === 4" color="red">作废</a-tag>
                    </span>
                    <a-button
                      type="primary"
                      size="small"
                      v-if="!item.hasPurchase && item.checkStatus === 2"
                      @click="editClick(item, 'c')"
                    >转采购单</a-button>
                  </div>
                  <!-- <div style="position: absolute; left: 600px; bottom: 13px;">
                  <a-button type="primary" v-if="!item.hasPurchase" @click="editClick(item, 'c')">
                    转采购单
                  </a-button>
                  </div>-->
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination"-->
            <!--               v-if="followData.purchaseRequisitionList ? followData.purchaseRequisitionList.length : 0">-->
            <!--            &lt;!&ndash; <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> &ndash;&gt;-->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          class="tabpane3"
          :tab="isPurchaseNotes ? `项目预付(${followData.prePaymentListCount ? followData.prePaymentListCount : 0})` : `预支预付(${followData.prePaymentListCount ? followData.prePaymentListCount : 0})`"
          v-if="followData.prePaymentListCount ? followData.prePaymentListCount : 0"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.prePaymentListCount ? followData.prePaymentListCount : 0"
            >
              <a-timeline-item v-for="item in prePaymentList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="retweet" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ isPurchaseNotes ? '项目预付' : '预支预付' }}</span>
                  <!-- <span v-if="isPurchaseNotes"> -->
                  <span>
                    <a-tag color="green" v-if="item.drawStatus === 1">已支取</a-tag>
                    <a-tag color="red" v-if="item.drawStatus === 0">未支取</a-tag>
                    <a-tag color="cyan" v-if="item.drawStatus === 2">部分支取</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span>{{ item.paymentType === 0 ? '[预支]' : '[预付]' }}</span>&nbsp;&nbsp;
                    <span
                      class="clickable"
                      @click="clickType(item.id, '预支预付', 'financialManage/advance/show.vue')"
                    >
                      {{
                      item.subject }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.applicationTime }})</span>&nbsp;&nbsp;
                    <span>{{ item.properser }}</span>&nbsp;&nbsp;
                    <span v-if="item.amount !== '' && item.amount !== null">
                      申请金额:
                      ￥{{ parseFloat(item.amount).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;/&nbsp;
                    <span
                      v-if="item.actualAmount !== '' && item.actualAmount !== null"
                    >
                      实际金额（元）:￥{{
                      parseFloat(item.actualAmount).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>
                    <template>
                      <span>
                        <a-tag v-show="item.checkStatus === 3" color="red">未通过</a-tag>
                        <a-tag v-show="item.checkStatus === 2" color="green">通过</a-tag>
                        <a-tag v-show="item.checkStatus === 1" color="cyan">审核中</a-tag>
                        <a-tag v-show="item.checkStatus === 0" color="orange">未审核</a-tag>
                      </span>
                    </template>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.prePaymentList ? followData.prePaymentList.length : 0">-->
            <!--            &lt;!&ndash; <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> &ndash;&gt;-->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="3"
          class="tabpane3"
          :tab="`合同(${followData.contractListCount ? followData.contractListCount : 0})`"
          v-if="(followData.contractListCount ? followData.contractListCount : 0) && (this.$tree([], 'contractManage/contractOrder/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.contractListCount ? followData.contractListCount : 0"
            >
              <a-timeline-item v-for="item in contractList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="smile" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">合同</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span>
                      <span
                        class="clickable"
                        @click="openViews(item, 'contractName')"
                      >{{ item.contractTitle }}</span>
                      <!-- {{ item.people }} -->
                    </span>&nbsp;&nbsp;
                    <span>({{ item.signDate }})</span>&nbsp;&nbsp;
                    <span>
                      ¥{{ parseFloat(item.backMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }} / ¥{{
                      parseFloat(item.contractMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;
                    <span>
                      <a-tag v-if="item.contractState === 0" color="blue">执行中</a-tag>
                      <a-tag v-if="item.contractState === 1" color="orange">结束</a-tag>
                      <a-tag v-if="item.contractState === 2" color="red">意外中止</a-tag>
                    </span>
                    <!-- <span v-if="item.contractState === 0">执行中</span>
          <span v-if="item.contractState === 1">结束</span>
                    <span v-if="item.contractState === 2">意外中止</span>-->
                    <span>{{ item.customerName }}</span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.contractList ? followData.contractList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="4"
          class="tabpane3"
          :tab="`${this.$tree([], 'financialManage/ticketReceiptRecord/index')}(${followData.invoiceReceiptListCount ? followData.invoiceReceiptListCount : 0})`"
          v-if="(followData.invoiceReceiptListCount ? followData.invoiceReceiptListCount : 0) && (this.$tree([], 'financialManage/ticketReceiptRecord/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.invoiceReceiptListCount ? followData.invoiceReceiptListCount : 0"
            >
              <a-timeline-item
                v-for="item in invoiceReceiptList"
                class="timelineItem"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span
                    class="lisType"
                  >{{ that.$tree([], 'financialManage/ticketReceiptRecord/index') }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'financialManage/ticketReceiptRecord/index'), 'financialManage/ticketReceiptRecord/viewCollection.vue')"
                    >
                      {{
                      item.invoiceContent }}
                    </span>&nbsp;&nbsp;
                    <span v-if="item.invoiceMoney !== '' && item.invoiceMoney !== null">
                      ￥{{
                      parseFloat(item.invoiceMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.invoiceDate }})</span>&nbsp;&nbsp;
                    <span>{{ item.customerName }}</span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.invoiceReceiptList ? followData.invoiceReceiptList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="5"
          class="tabpane3"
          :tab="`${this.$tree([], 'financialManage/billingRecords/index')}(${followData.invoiceGiveListCount ? followData.invoiceGiveListCount : 0})`"
          v-if="(followData.invoiceGiveListCount ? followData.invoiceGiveListCount : 0) && (this.$tree([], 'financialManage/billingRecords/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.invoiceGiveListCount ? followData.invoiceGiveListCount : 0"
            >
              <a-timeline-item v-for="item in invoiceGiveList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'financialManage/billingRecords/index') }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.handledBy }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'financialManage/billingRecords/index'), 'financialManage/billingRecords/viewBill.vue')"
                    >
                      {{
                      item.invoiceContent }}
                    </span>&nbsp;&nbsp;
                    <span>{{ item.invoiceDate }}</span>&nbsp;&nbsp;
                    <span v-if="item.invoiceMoney !== '' && item.invoiceMoney !== null">
                      ￥{{
                      parseFloat(item.invoiceMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span>{{ item.customerName }}</span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.invoiceGiveList ? followData.invoiceGiveList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="6"
          class="tabpane3"
          :tab="`${this.$tree([], 'contractManage/paymentPlan/index')}(${followData.payBackPlanListCount ? followData.payBackPlanListCount : 0})`"
          v-if="(followData.payBackPlanListCount ? followData.payBackPlanListCount : 0) && (this.$tree([], 'contractManage/paymentPlan/index') ? true : false)"
          style="margin-left: 0px;"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.payBackPlanListCount ? followData.payBackPlanListCount : 0"
            >
              <a-timeline-item v-for="item in payBackPlanList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'contractManage/paymentPlan/index') }}</span>
                  <span>
                    <a-tag v-if="item.backInvoice === 0" color="orange">未开票</a-tag>
                    <a-tag v-if="item.backInvoice === 1" color="green">已开票</a-tag>
                    <a-tag v-if="item.backInvoice === 2">无需开票</a-tag>
                  </span>
                  <span>
                    <a-tag v-if="item.backStatus === 0" color="red">未回款</a-tag>
                    <a-tag v-if="item.backStatus === 1" color="blue">已回款</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'contractManage/paymentPlan/index'), 'contractManage/paymentPlan/show.vue')"
                    >
                      {{
                      item.projectName }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.backDate }})</span>&nbsp;&nbsp;
                    <span v-if="item.backMoney !== '' && item.backMoney !== null">
                      ¥{{
                      parseFloat(item.backMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <span>{{ item.customerName }}</span>
                    <a-button
                      v-if="item.backInvoice === 0"
                      type="primary"
                      size="small"
                      @click="editClick(item, 'b')"
                    >开票</a-button>
                  </div>
                  <!-- <div v-if="item.backInvoice === 0" style="position: absolute; left: 600px; bottom: 13px;">
                  <a-button type="primary" @click="editClick(item, 'b')">
                    开票
                  </a-button>
                  </div>-->
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.payBackPlanList ? followData.payBackPlanList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="7"
          class="tabpane3"
          :tab="`${this.$tree([], 'contractManage/paymentRecord/index')}(${followData.payBackRecordListCount ? followData.payBackRecordListCount : 0})`"
          v-if="(followData.payBackRecordListCount ? followData.payBackRecordListCount : 0) && (this.$tree([], 'contractManage/paymentRecord/index') ? true : false)"
          style="margin-left: 0px;"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.payBackRecordListCount ? followData.payBackRecordListCount : 0"
            >
              <a-timeline-item
                v-for="item in payBackRecordList"
                class="timelineItem"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'contractManage/paymentRecord/index') }}</span>
                  <span>
                    <a-tag v-if="item.backInvoice === 0" color="orange">未开票</a-tag>
                    <a-tag v-if="item.backInvoice === 1" color="green">已开票</a-tag>
                    <a-tag v-if="item.backInvoice === 2">无需开票</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'contractManage/paymentRecord/index'), 'contractManage/paymentRecord/show.vue')"
                      v-if="item.backMoney !== '' && item.backMoney !== null"
                    >
                      ￥{{
                      parseFloat(item.backMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.backDate }})</span>&nbsp;&nbsp;
                    <span>冲销金额</span>
                    <span>{{ item.backCxMoney }}</span>
                    <!--                  <span>-->
                    <!--                    {{ item.projectName }}-->
                    <!--                  </span>&nbsp;&nbsp;-->
                    <!--                  <span>{{ item.customerName }}</span>-->
                    <template>
                      <span>
                        <a-tag v-show="item.checkStatus === 3" color="red">未通过</a-tag>
                        <a-tag v-show="item.checkStatus === 2" color="green">通过</a-tag>
                        <a-tag v-show="item.checkStatus === 1" color="cyan">审核中</a-tag>
                        <a-tag v-show="item.checkStatus === 0" color="orange">未审核</a-tag>
                      </span>
                    </template>
                    <a-button
                      v-if="item.backInvoice === 0"
                      type="primary"
                      size="small"
                      @click="editClick(item, 'b')"
                    >开票</a-button>
                  </div>
                  <!-- <div v-if="item.backInvoice === 0" style="position: absolute; left: 500px; bottom: 13px;">
                  <a-button type="primary" @click="editClick(item, 'b')">
                    开票
                  </a-button>
                  </div>-->
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.payBackRecordList ? followData.payBackRecordList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="8"
          class="tabpane3"
          :tab="`${this.$tree([], 'purchase/paymentSchedule/index')}(${followData.payPlanListCount ? followData.payPlanListCount : 0})`"
          v-if="(followData.payPlanListCount ? followData.payPlanListCount : 0) && (this.$tree([], 'purchase/paymentSchedule/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.payPlanListCount ? followData.payPlanListCount : 0"
            >
              <a-timeline-item v-for="item in payPlanList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'purchase/paymentSchedule/index') }}</span>
                  <span>
                    <a-tag v-if="item.payInvoice === 0" color="orange">未收票</a-tag>
                    <a-tag v-if="item.payInvoice === 1" color="green">已收票</a-tag>
                    <a-tag v-if="item.payInvoice === 2">无需收票</a-tag>
                  </span>
                  <span>
                    <a-tag v-if="item.payStatus === 0" color="red">未付款</a-tag>
                    <a-tag v-if="item.payStatus === 1" color="blue">已付款</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'purchase/paymentSchedule/index'), 'purchase/paymentSchedule/paymentInfor.vue')"
                      v-if="item.payMoney !== '' && item.payMoney !== null"
                    >
                      ￥{{
                      parseFloat(item.payMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.payDate }})</span>&nbsp;&nbsp;
                    <span :style="`color: ${systemColor}`">{{ item.customerName }}</span>&nbsp;&nbsp;
                    <span v-if="item.purchaseName !== '' && item.purchaseName !== null">
                      {{ item.purchaseName
                      }}
                    </span>&nbsp;&nbsp;
                    <template>
                      <span>
                        <a-tag v-show="item.checkStatus === 3" color="red">审核未通过</a-tag>
                        <a-tag v-show="item.checkStatus === 2" color="green">审核通过</a-tag>
                        <a-tag v-show="item.checkStatus === 1" color="cyan">审核中</a-tag>
                        <a-tag v-show="item.checkStatus === 0" color="orange">未审核</a-tag>
                      </span>
                      <a-button
                        v-if="item.payInvoice === 0"
                        type="primary"
                        size="small"
                        @click="editClick(item, 'a')"
                      >收票</a-button>
                    </template>
                  </div>
                  <!-- <div v-if="item.payInvoice === 0" style="position: absolute; left: 600px; bottom: 13px;">
                  <a-button type="primary" size="small" @click="editClick(item, 'a')">
                    收票
                  </a-button>
                  </div>-->
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.payPlanList ? followData.payPlanList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="9"
          class="tabpane3"
          :tab="`${this.$tree([], 'purchase/paymentRecords/index')}(${followData.payPlanRecordListCount ? followData.payPlanRecordListCount : 0})`"
          v-if="(followData.payPlanRecordListCount ? followData.payPlanRecordListCount : 0) && (this.$tree([], 'purchase/paymentRecords/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.payPlanRecordListCount ? followData.payPlanRecordListCount : 0"
            >
              <a-timeline-item
                v-for="item in payPlanRecordList"
                class="timelineItem"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'purchase/paymentRecords/index') }}</span>
                  <span>
                    <a-tag v-if="item.payInvoice === 0" color="orange">未收票</a-tag>
                    <a-tag v-if="item.payInvoice === 1" color="green">已收票</a-tag>
                    <a-tag v-if="item.payInvoice === 2">无需收票</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'purchase/paymentRecords/index'), 'purchase/paymentRecords/recordInform.vue')"
                      v-if="item.payMoney !== '' && item.payMoney !== null"
                    >
                      ￥{{
                      parseFloat(item.payMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.payDate }})</span>&nbsp;&nbsp;
                    <span>{{ item.purchaseName }}</span>&nbsp;&nbsp;
                    <span>{{ item.customerName }}</span>
                    <a-button
                      v-if="item.payInvoice === 0"
                      type="primary"
                      size="small"
                      @click="editClick(item, 'a')"
                    >收票</a-button>
                  </div>
                  <!-- <div v-if="item.payInvoice === 0" style="position: absolute; left: 600px; bottom: 13px;">
                  <a-button type="primary" @click="editClick(item, 'a')">
                    收票
                  </a-button>
                  </div>-->
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.payPlanRecordList ? followData.payPlanRecordList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="10"
          class="tabpane2"
          :tab="`${this.$tree([], 'purchase/purchaseNote/index')}(${followData.purchaseListCount ? followData.purchaseListCount : 0})`"
          v-if="(followData.purchaseListCount ? followData.purchaseListCount : 0) && (this.$tree([], 'purchase/purchaseNote/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.purchaseListCount ? followData.purchaseListCount : 0"
            >
              <a-timeline-item v-for="item in purchaseList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ that.$tree([], 'purchase/purchaseNote/index') }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>&nbsp;&nbsp;
                    <a-tag
                      v-if="item.amortizeFlag !== null && item.amortizeFlag !== undefined && item.amortizeFlag !== 0"
                      color="green"
                    >其他项目摊销</a-tag>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span class="clickable" @click="openViews(item, 'purchaseName')">
                      {{ item.subject
                      }}
                    </span>&nbsp;&nbsp;
                    <span>({{ item.purchaseDate }})</span>&nbsp;&nbsp;
                    <span v-if="item.totalPrice !== '' && item.totalPrice !== null">
                      采购金额：
                      ￥{{
                      parseFloat(item.totalPrice).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;/&nbsp;
                    <span v-if="item.actualMoney !== '' && item.actualMoney !== null">
                      实际金额：
                      ￥{{
                      parseFloat(item.actualMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <span>{{ item.suppliersName }}</span>
                    <template>
                      <span>
                        <a-tag v-show="item.checkStatus === 3" color="red">未通过</a-tag>
                        <a-tag v-show="item.checkStatus === 2" color="green">通过</a-tag>
                        <a-tag v-show="item.checkStatus === 1" color="cyan">审核中</a-tag>
                        <a-tag v-show="item.checkStatus === 0" color="orange">未审核</a-tag>
                      </span>
                    </template>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="11"
          class="tabpane2"
          :tab="`${this.$tree([], 'projectManage/humanCost/index')}(${followData.humanCostListCount ? followData.humanCostListCount : 0})`"
          v-if="(followData.humanCostListCount ? followData.humanCostListCount : 0) && (this.$tree([], 'projectManage/humanCost/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.humanCostListCount ? followData.humanCostListCount : 0"
            >
              <a-timeline-item v-for="item in humanCostList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span
                    class="lisType clickable"
                    @click="clickType(item.id, that.$tree([], 'projectManage/humanCost/index'), 'projectManage/humanCost/detail.vue')"
                  >
                    {{
                    that.$tree([], 'projectManage/humanCost/index') }}
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span class="clickable" @click="openView(item, 'customerName')">
                      {{ item.customerName
                      }}
                    </span>&nbsp;&nbsp;
                    <span>{{ item.inputTime }}</span>&nbsp;&nbsp;
                    <!-- <span>
                    {{ item.humanInput ? '投入人力（人/日）:' + item.humanInput : '投入人力（人/日）:' + 0 }}
                  </span>&nbsp;&nbsp;
                  <span v-if="item.perHumanCost !== '' && item.perHumanCost !== null">
                    个人成本（人/日/元）:￥{{ parseFloat(item.perHumanCost).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>&nbsp;&nbsp;-->
                    <span v-if="item.humanCost !== '' && item.humanCost !== null">
                      人员总成本（元）:￥{{
                      parseFloat(item.humanCost).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <!-- <span>
                    {{ item.suppliersName }}
                    </span>-->
                    <!-- <template>
                    <span>
                      <a-tag v-show="item.checkStatus === 3" color="red">
                        未通过
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 2" color="green">
                        通过
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 1" color="cyan">
                        审核中
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 0" color="orange">
                        未审核
                      </a-tag>
                    </span>
                    </template>-->
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="12"
          class="tabpane2"
          :tab="`${this.$tree([], 'offices/courtesyApplication/index')}(${followData.festivalGiftListCount ? followData.festivalGiftListCount : 0})`"
          v-if="(followData.festivalGiftListCount ? followData.festivalGiftListCount : 0) && (this.$tree([], 'offices/courtesyApplication/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.festivalGiftListCount ? followData.festivalGiftListCount : 0"
            >
              <a-timeline-item v-for="item in festivalGiftList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span>{{ that.$tree([], 'offices/courtesyApplication/index') }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span
                      @click="clickType(item.id, that.$tree([], 'offices/courtesyApplication/index'), 'offices/courtesyApplication/details.vue')"
                      class="lisType clickable"
                    >{{ item.subject }}</span>&nbsp;&nbsp;
                    <span>{{ item.applyDate }}</span>&nbsp;&nbsp;
                    <span>{{ item.peopleName }}</span>&nbsp;&nbsp;
                    <!-- <span>
                    {{ item.humanInput ? '投入人力（人/日）:' + item.humanInput : '投入人力（人/日）:' + 0 }}
                  </span>&nbsp;&nbsp;
                  <span v-if="item.perHumanCost !== '' && item.perHumanCost !== null">
                    个人成本（人/日/元）:￥{{ parseFloat(item.perHumanCost).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>&nbsp;&nbsp;-->
                    <span v-if="item.amount !== '' && item.amount !== null">
                      申请金额（元）:￥{{
                      parseFloat(item.amount).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2, maximumFractionDigits:
                      2
                      })
                      }}
                    </span>&nbsp;/&nbsp;
                    <span
                      v-if="item.actualAmount !== '' && item.actualAmount !== null"
                    >
                      实际金额（元）:￥{{
                      parseFloat(item.actualAmount).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;/&nbsp;
                    <span v-if="item.drawAmount !== '' && item.drawAmount !== null">
                      支取金额（元）:￥{{
                      parseFloat(item.drawAmount).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <a-tag color="green" v-if="item.checkStatus === 1">已支取</a-tag>
                    <a-tag color="red" v-if="item.checkStatus === 0">未支取</a-tag>
                    <!-- <span>
                    {{ item.suppliersName }}
                    </span>-->
                    <!-- <template>
                    <span>
                      <a-tag v-show="item.checkStatus === 3" color="red">
                        未通过
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 2" color="green">
                        通过
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 1" color="cyan">
                        审核中
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 0" color="orange">
                        未审核
                      </a-tag>
                    </span>
                    </template>-->
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="13"
          class="tabpane2"
          :tab="`${this.$tree([], 'projectManage/fundCost/index')}(${followData.fundCostListCount ? followData.fundCostListCount : 0})`"
          v-if="(followData.fundCostListCount ? followData.fundCostListCount : 0) && (this.$tree([], 'projectManage/fundCost/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.fundCostListCount ? followData.fundCostListCount : 0"
            >
              <a-timeline-item v-for="item in fundCostList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span
                    class="lisType clickable"
                    @click="clickType(item.id, that.$tree([], 'projectManage/fundCost/index'), 'projectManage/fundCost/detail.vue')"
                  >
                    {{
                    that.$tree([], 'projectManage/fundCost/index') }}
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span class="clickable" @click="openView(item, 'customerName')">
                      {{ item.customerName
                      }}
                    </span>&nbsp;&nbsp;
                    <!-- <span
                      class="clickable"
                      @click="openView(item, 'contractName')"
                    >{{ item.contractName }}</span>&nbsp;&nbsp;-->
                    <!-- <span>
                    {{ item.humanInput ? '投入人力（人/日）:' + item.humanInput : '投入人力（人/日）:' + 0 }}
                  </span>&nbsp;&nbsp;
                  <span v-if="item.perHumanCost !== '' && item.perHumanCost !== null">
                    个人成本（人/日/元）:￥{{ parseFloat(item.perHumanCost).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>&nbsp;&nbsp;-->
                    <span>{{ projectTypeObj[item.projectType] }}</span>&nbsp;&nbsp;
                    <span>{{ fundTypeObj[item.fundType] }}</span>&nbsp;&nbsp;
                    <span
                      v-if="item.contractMoney !== '' && item.contractMoney !== null"
                    >
                      项目资金（元）:￥{{
                      parseFloat(item.contractMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span
                      v-if="item.fundCostMoney !== '' && item.fundCostMoney !== null"
                    >
                      资金占用成本（元）:￥{{
                      parseFloat(item.fundCostMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span>
                      <a-tag color="green" v-if="item.status === 0">进行中</a-tag>
                      <a-tag color="red" v-if="item.status === 1">结束</a-tag>
                    </span>
                    <!-- <span>
                    {{ item.suppliersName }}
                    </span>-->
                    <!-- <template>
                    <span>
                      <a-tag v-show="item.checkStatus === 3" color="red">
                        未通过
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 2" color="green">
                        通过
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 1" color="cyan">
                        审核中
                      </a-tag>
                      <a-tag v-show="item.checkStatus === 0" color="orange">
                        未审核
                      </a-tag>
                    </span>
                    </template>-->
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <!-- 采购退款记录 -->
        <a-tab-pane
          key="14"
          class="tabpane2"
          :tab="`${this.$tree([], 'purchase/purchRefundRec/index')}(${followData.payRefundListCount ? followData.payRefundListCount : 0})`"
          v-if="(followData.payRefundListCount ? followData.payRefundListCount : 0) && (this.$tree([], 'purchase/purchRefundRec/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.payRefundListCount ? followData.payRefundListCount : 0"
            >
              <a-timeline-item v-for="item in payRefundList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span
                    class="lisType clickable"
                    @click="clickType(item.id, that.$tree([], 'purchase/purchRefundRec/index'), 'purchase/purchRefundRec/detail.vue')"
                  >
                    {{
                    that.$tree([], 'purchase/purchRefundRec/index') }}
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>> 对应采购单：</span>
                    <span class="clickable" @click="openView(item, 'purchaseName')">
                      {{ item.purchaseName
                      }}
                    </span>
                    <!-- <span>项目：</span>
                    <span class="clickable" @click="openView(item, 'projectName')">
                      {{ item.projectName
                      }}
                    </span>-->
                  </div>
                  <div class="lisContent">
                    <span>></span>
                    <span class="clickable" @click="openView(item, 'customerName')">
                      {{ item.customerName
                      }}
                    </span>&nbsp;&nbsp;
                    <span>{{ projectTypeObj[item.projectType] }}</span>&nbsp;&nbsp;
                    <span>{{ fundTypeObj[item.fundType] }}</span>&nbsp;&nbsp;
                    <span v-if="item.returnMoney !== '' && item.returnMoney !== null">
                      退款金额（元）:￥{{
                      parseFloat(item.returnMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span v-if="item.payCxMoney !== '' && item.payCxMoney !== null">
                      冲销金额（元）:￥{{
                      parseFloat(item.payCxMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span>
                      <a-tag color="green" v-if="item.isPaid === 0">抵扣未付款</a-tag>
                    </span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <!-- 其他项目摊销费用 -->
        <a-tab-pane
          key="15"
          class="tabpane2"
          :tab="`${'其他项目摊销费用'}(${followData.payAmortizeListCount ? followData.payAmortizeListCount : 0})`"
          v-if="(followData.payAmortizeListCount ? followData.payAmortizeListCount : 0) ? true : false"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.payAmortizeListCount ? followData.payAmortizeListCount : 0"
            >
              <a-timeline-item v-for="item in payAmortizeList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ item.subject }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>> 其他项目：</span>
                    <span class="clickable" @click="openView(item, 'amortizeProjectName')">
                      {{ item.amortizeProjectName
                      }}
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>采购单：</span>
                    <span class="clickable" @click="openView(item, 'amortizePurchaseName')">
                      {{ item.amortizePurchaseName
                      }}
                    </span>
                  </div>
                  <div class="lisContent">
                    <span>> 摊销类型：</span>
                    <span>
                      <a-tag v-if="item.type === 0" color="#2db7f5">退回仓库摊销</a-tag>
                      <a-tag v-if="item.type === 1" color="#87d068">领用摊销</a-tag>
                      <a-tag v-if="item.type === 2" color="#108ee9">归还摊销</a-tag>
                      <a-tag v-if="item.type === 4" color="#20d3d3">结转摊销</a-tag>
                      <!-- <span v-if="item.type === 1">退回仓库摊销</span>
                      <span v-if="item.type === 2">领用摊销</span>
                      <span v-if="item.type === 3">归还摊销</span>-->
                    </span>&nbsp;&nbsp;
                    <!-- <span>{{ projectTypeObj[item.projectType] }}</span>&nbsp;&nbsp;
                    <span>{{ fundTypeObj[item.fundType] }}</span>&nbsp;&nbsp;-->
                    <span v-if="item.returnMoney !== '' && item.returnMoney !== null">
                      摊销金额（元）:￥{{
                      parseFloat(item.amortizeMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;/&nbsp;
                    <span
                      v-if="item.returnMoney !== '' && item.returnMoney !== null && item.returnMoney !== 0"
                    >
                      归还金额（元）:￥{{
                      parseFloat(item.returnMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:
                      2
                      }) }}
                    </span>&nbsp;&nbsp;
                    <span>
                      <a-tag color="green" v-if="item.isPaid === 0">抵扣未付款</a-tag>
                    </span>
                    <!-- <span v-if="item.payCxMoney !== '' && item.payCxMoney !== null">
                      冲销金额（元）:￥{{
                        parseFloat(item.payCxMoney).toLocaleString('zh-CN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits:
                            2
                        }) }}
                    </span>&nbsp;&nbsp;-->
                    <!-- <span>
                      <a-tag color="green" v-if="item.status === 0">进行中</a-tag>
                      <a-tag color="red" v-if="item.status === 1">结束</a-tag>
                    </span>-->
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <!-- 跟进信息 -->
        <a-tab-pane
          key="16"
          class="tabpane2"
          :tab="`${'跟进记录'}(${followData.opportunityLogCount ? followData.opportunityLogCount : 0})`"
          v-if="(followData.opportunityLogCount ? followData.opportunityLogCount : 0) ? true : false"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.opportunityLogCount ? followData.opportunityLogCount : 0"
            >
              <a-timeline-item
                v-for="item in opportunityLogList"
                class="timelineItem"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ item.subject }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>> 主题：</span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, '跟进记录', 'salesOpportunities/projectOpportunities/followDetails.vue')"
                    >
                      {{ item.title
                      }}
                    </span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="17"
          class="tabpane2"
          :tab="`${'合同增补核减'}(${followData.supplementListCount ? followData.supplementListCount : 0})`"
          v-if="(followData.supplementListCount ? followData.supplementListCount : 0) ? true : false"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.supplementListCount ? followData.supplementListCount : 0"
            >
              <a-timeline-item v-for="item in supplementList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ item.subject }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>> 标题：</span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'contractManage/contractManagement/index'), 'contractManage/contractManagement/details.vue')"
                    >
                      {{ item.title
                      }}
                    </span>
                  </div>
                  <div class="lisContent">
                    <span>> 金额：</span>
                    <span>
                      ￥{{
                      parseFloat(item.supplementMoney).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="18"
          class="tabpane2"
          :tab="`${this.$tree([], 'contractManage/earnestMoney/index')}(${followData.performanceBondListCount ? followData.performanceBondListCount : 0})`"
          v-if="(followData.performanceBondListCount ? followData.performanceBondListCount : 0) && (this.$tree([], 'contractManage/earnestMoney/index') ? true : false)"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.performanceBondListCount ? followData.performanceBondListCount : 0"
            >
              <a-timeline-item
                v-for="item in performanceBondList"
                class="timelineItem"
                :key="item.id"
              >
                <template>
                  <a-icon slot="dot" type="pay-circle" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span>
                    {{
                    that.$tree([], 'contractManage/earnestMoney/index') }}
                  </span>&nbsp;&nbsp;
                  <span>
                    <a-tag color="orange" v-if="item.status === 1">未支取</a-tag>
                    <a-tag color="green" v-if="item.status === 2">已支取</a-tag>
                    <a-tag color="cyan" v-if="item.status === 3">已返还</a-tag>
                  </span>
                  <div class="nameBox">
                    <span class="name">{{ item.applicant }}</span>
                    <span class="time">• 申请日期：{{ item.applicantDate }}</span>
                  </div>
                  <div class="lisContent">
                    <!-- <span>></span>
                    <span>
                      合同：
                      <span
                        class="clickable"
                        @click="openView(item, 'contractName')"
                      >{{ item.contractTitle }}</span>
                    </span>
                    <br />
                    <span>></span>
                    项目：
                    <span
                      class="clickable"
                      @click="openView(item, 'project')"
                    >{{ item.projectName }}</span>
                    <br />-->
                    <span>></span>
                    保证金：
                    <span
                      class="lisType clickable"
                      v-if="item.bond !== '' && item.bond !== null"
                      @click="clickType(item.id, that.$tree([], 'contractManage/earnestMoney/index'), 'contractManage/earnestMoney/detail.vue')"
                    >
                      ¥{{ parseFloat(item.bond).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>
                    <template>
                      <span>
                        <a-tag v-show="item.checkStatus === 3" color="red">未通过</a-tag>
                        <a-tag v-show="item.checkStatus === 2" color="green">通过</a-tag>
                        <a-tag v-show="item.checkStatus === 1" color="cyan">审核中</a-tag>
                        <a-tag v-show="item.checkStatus === 0" color="orange">未审核</a-tag>
                      </span>
                    </template>
                    <br />
                    <span>></span>
                    保证金类别：
                    <span class="lisType">
                      <a-tag color="#2db7f5" v-if="item.bondType === 0">履约保证金</a-tag>
                      <a-tag color="#87d068" v-if="item.bondType === 1">投标保证金</a-tag>
                    </span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
          </a-spin>
        </a-tab-pane>
        <a-tab-pane
          key="19"
          class="tabpane2"
          :tab="`${this.$tree([], 'offices/operatingCosts/index')}(${followData.operatingCount ? followData.operatingCount : 0})`"
          v-if="(followData.operatingCount ? followData.operatingCount : 0) ? true : false"
        >
          <a-spin :spinning="spinning">
            <a-timeline
              class="timeLineDer"
              v-if="followData.operatingCount ? followData.operatingCount : 0"
            >
              <a-timeline-item v-for="item in operatingCostsList" class="timelineItem" :key="item.id">
                <template>
                  <a-icon slot="dot" type="dollar" style="font-size: 30px;" />
                </template>
                <div class="lis" style="margin-left: 20px;">
                  <span class="lisType">{{ item.subject }}</span>
                  <div class="nameBox">
                    <span class="name">{{ item.creator }}</span>
                    <span class="time">• 创建：{{ item.createTime }}</span>
                  </div>
                  <div class="lisContent">
                    <span>> 标题：</span>
                    <span
                      class="clickable"
                      @click="clickType(item.id, that.$tree([], 'offices/operatingCosts/index'), 'offices/operatingCosts/details.vue')"
                    >
                      {{ item.costTheme }}
                    </span>
                  </div>
                  <div class="lisContent">
                    <span>> 金额：</span>
                    <span>
                      ￥{{
                      parseFloat(item.money).toLocaleString('zh-CN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      })
                      }}
                    </span>&nbsp;&nbsp;
                    <span> 所属公司：</span>
                    <span>
                      {{subsidiaryObj[item.company]}}
                    </span>&nbsp;&nbsp;
                    <span> 所属年度：</span>
                    <span>
                      {{item.year}}
                    </span>&nbsp;&nbsp;
                    <span> 月份：</span>
                    <span>
                      {{item.month}}
                    </span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-else />
            <!--          <div class="pagination" v-if="followData.purchaseList ? followData.purchaseList.length : 0">-->
            <!-- <a-pagination show-quick-jumper :default-current="1" :pageSize="pagination.pageSize" :current="pagination.pageNum" :total="followDataNum.all" @change="onChange" /> -->
            <!--          </div>-->
          </a-spin>
        </a-tab-pane>
      </a-tabs>
      <div class="pagination">
        <Paging
          :current="current"
          :total="pagination.totalCount"
          simple
          :pagination="pagination"
          :page-size="pagination.pageSize"
          :default-current="1"
          ref="paginations"
          :pageSizeOptions="pageSizeOptions"
          @onShowSizeChange="onShowSizeChange"
        />
      </div>
    </div>
    <div v-if="emtyTitles">
      <a-empty style="position: relative;" />
    </div>
    <publicDrawer
      v-if="publicDrawer.visible"
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @projectChanges="projectChanges"
      @editClick="clickType"
      @close="publicDrawerClose"
    />
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
  </div>
</template>
<script>
import Paging from '../../components/paging/index.vue'
import publicDrawer from '../../components/drawer/publicDrawer.vue'
import clickView from '../../components/view/clickView.vue'
export default {
  name: 'TimeLine',
  components: { Paging, publicDrawer, clickView },
  props: {
    emtyTitle: {
      type: Boolean,
      default: false
    },
    emtyTime: {
      type: Boolean,
      default: true
    },
    isPurchaseNote: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emtyTitles: this.emtyTitle,
      emtyTimes: this.emtyTime,
      isPurchaseNotes: this.isPurchaseNote,
      activeIndex: 0,
      isOpenDreawer: false,
      clickViewVisible: false,
      pageSizeOptions: ['5', '10', '15', '20'],
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      },
      followData: {},
      current: 1,
      pagination: {
        current: 1,
        pageSize: 10,
        totalCount: 1
      },
      that: {},
      reimbursementList: [],
      purchaseRequisitionList: [],
      prePaymentList: [],
      contractList: [],
      invoiceGiveList: [],
      invoiceReceiptList: [],
      payBackPlanList: [],
      payBackRecordList: [],
      payPlanList: [],
      payPlanRecordList: [],
      purchaseList: [],
      humanCostList: [],
      festivalGiftList: [],
      payAmortizeList: [],
      opportunityLogList: [], // 跟进记录
      fundCostList: [],
      amortRecList: [], // 摊销记录
      returnRecList: [], // 归还记录
      payRefundList: [], // 采购退款记录
      supplementList: [], // 合同增减
      operatingCostsList: [],
      subsidiaryObj: {},
      performanceBondList: [], // 保证金
      projectTypeList: [],
      projectTypeObj: {},
      fundTypeObj: {},
      spinning: false,
      followType: 0,
      activeId: null,
      type: null
    }
  },
  mounted () {
    this.that = this
    this.projectTypeList = this.$store.state.account.dictData.projectTypeList
    this.subsidiaryObj = this.$store.state.account.dictData.subsidiaryObj
    console.log('this.subsidiaryObj===>', this.subsidiaryObj)
    this.projectTypeList.forEach(item => {
      this.projectTypeObj[item.label] = item.value
    })
    // console.log('this.$tree([], \'purchase/purchaseNote/index\') =>', this.$tree([], 'purchase/purchaseNote/index') ? 'true' : 'false')
    this.getFunCost()
  },
  methods: {
    getFunCost () {
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'fundCostType' }).then(res => {
        res.data.data.forEach(item => {
          // this.fundTypeList.push({
          //   label: item.dictName,
          //   value: item.dictCode
          // })
          this.fundTypeObj[item.dictCode] = item.dictName
        })
      })
    },
    // judgment () {
    //   let arr = ['reimbursementList', 'purchaseRequisitionList', 'prePaymentList', 'contractList', 'invoiceReceiptList', 'invoiceGiveList', 'payBackPlanList', 'payBackRecordList', 'payPlanList', 'payPlanRecordList', 'purchaseList']
    //   for (let item of arr) {
    //     if (this.followData[item] && this.followData[item].length === 0) {
    //       this.emtyTitles = true
    //       this.emtyTimes = false
    //     }
    //   }
    // },
    // 如果所有的count都为0 则显示空状态
    isNull () {
      let arr = ['reimbursementListCount', 'purchaseRequisitionListCount', 'prePaymentListCount', 'contractListCount', 'invoiceReceiptListCount', 'invoiceGiveListCount', 'payBackPlanListCount', 'payBackRecordListCount', 'payPlanListCount', 'payPlanRecordListCount', 'purchaseListCount', 'humanCostListCount', 'festivalGiftListCount', 'fundCostListCount', 'payRefundListCount', 'payAmortizeListCount', 'opportunityLogCount', 'supplementListCount', 'performanceBondListCount', 'operatingCount']
      // eslint-disable-next-line no-unused-vars
      let allZero = true
      for (const element of arr) {
        if (this.followData[element] !== 0) {
          allZero = false
          break
        }
      }
      if (allZero) {
        this.emtyTitles = true
        this.emtyTimes = false
      }
    },
    changeTime (e) {
      this.$set(this.pagination, this.pagination.current, 1)
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.activeIndex = e
      // this.isChange(e)
      // this.isPaging()
      // this.$forceUpdate()
      this.$refs.paginations.onShowSizeChange(this.pagination.current, this.pagination.pageSize)
    },
    onShowSizeChange (current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      // this.isPaging()
      console.log('this.activeIndex =>', this.activeIndex)

      this.initListData(this.activeIndex)
    },
    // 切割数组, 根据前端分页赋值
    // isPaging () {
    //   let arr = ['reimbursementList', 'purchaseRequisitionList', 'prePaymentList', 'contractList', 'invoiceReceiptList', 'invoiceGiveList', 'payBackPlanList', 'payBackRecordList', 'payPlanList', 'payPlanRecordList', 'purchaseList']
    //   for (let item of arr) {
    //     if (this.followData[item] && this.followData[item].length !== 0) {
    //       this[item] = this.followData[item].slice((this.pagination.current - 1) * this.pagination.pageSize, (this.pagination.current - 1) * this.pagination.pageSize + this.pagination.pageSize)
    //     }
    //   }
    // },
    // isChange (e) {
    //   if (e) {
    //     let arr = ['reimbursementList', 'purchaseRequisitionList', 'prePaymentList', 'contractList', 'invoiceReceiptList', 'invoiceGiveList', 'payBackPlanList', 'payBackRecordList', 'payPlanList', 'payPlanRecordList', 'purchaseList']
    //     if (this.followData[arr[e]]) {
    //       // 设置分页总条数
    //       this.pagination.totalCount = this.followData[arr[e]].length
    //     }
    //   } else {
    //     // 空状态
    //     this.emtyTitles = true
    //     this.emtyTimes = false
    //   }
    // },
    // path 为当前list接口, params为额外参数
    initListData (index, params = {}) {
      console.log(index)
      this.activeIndex = index
      this.spinning = true
      params.pageNum = this.pagination.current
      params.pageSize = this.pagination.pageSize
      params.followType = this.followType
      params.dataId = this.activeId
      if (this.type) params.customerType = this.type
      const pathList = ['/reimbursement/list', '/purchaseRequisition/list', '/prePayment/list', '/contract/list', '/invoice/list', '/invoice/list', '/payBack/list', '/payBack/list', '/payPlan/list', '/payPlan/list', '/purchase/list', '/humanCost/list', '/festivalGift/project', '/fundCost/list', '/payRefund/list', '/payAmortize/list', '/opportunityLog/list', '/contract/supplement/list', 'performance/list', '/operatingCosts/list']
      let arr = ['reimbursementList', 'purchaseRequisitionList', 'prePaymentList', 'contractList', 'invoiceReceiptList', 'invoiceGiveList', 'payBackPlanList', 'payBackRecordList', 'payPlanList', 'payPlanRecordList', 'purchaseList', 'humanCostList', 'festivalGiftList', 'fundCostList', 'payRefundList', 'payAmortizeList', 'opportunityLogList', 'supplementList', 'performanceBondList', 'operatingCostsList']
      switch (index) {
        case '4':
          params.type = 0
          break
        case '5':
          params.type = 1
          break
        case '6':
          params.backType = 0
          break
        case '7':
          params.backType = 1
          break
        case '8':
          params.payType = 0
          break
        case '9':
          params.payType = 1
          break
      }
      this.$get(pathList[index], params).then(res => {
        if (res.data.status === 1) {
          const newData = res.data.data
          if (Number(newData.total) > 0) {
            this[arr[index]] = newData.rows
            this.pagination.totalCount = Number(newData.total)
          }
          // console.log(this.payRefundList, '-----------')
        } else {
          this.$message.warning(res.data.message)
        }
      }).finally(_ => {
        this.spinning = false
      })
    },
    systemColor () {
      return this.$store.state.setting.color[0]
    },
    editClick (item, value) {
      this.$emit('invoiceListChange', item, value)
    },
    // 所有引入时间线组件从外面调用的方法
    getFollow (data, followType, id, type) {
      console.log(data, '数据', id)
      // followType 用来区分具体list
      this.followType = followType
      // 对应数据id
      this.activeId = id
      // type 仅客户/供应商使用
      this.type = type
      setTimeout(() => {
        // console.log(this.$refs.changeTime, this.$refs.changeTime.$children[0]._data._activeKey)
        // 传入当前tab激活标签页的key值
        if (this.$refs.changeTime && this.$refs.changeTime.$children[0]._data._activeKey) {
          this.activeIndex = this.$refs.changeTime.$children[0]._data._activeKey
          this.initListData(this.$refs.changeTime.$children[0]._data._activeKey)
        }
      }, 200)
      this.followData = data
      this.isNull()
    },
    clickTypeFun (way, title, path, id) {
      this.$get(way, { id: id }).then(res => {
        let resData = res.data
        if (resData.status === 1) {
          // 展开抽屉
          this.publicDrawer.title = title
          this.publicDrawer.comName = path
          this.publicDrawer.visible = true
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(resData.data, null, [resData.data.creator])
          })
        } else {
          this.$message.warning(resData.message)
        }
      })
    },
    clickType (id, name, path) { // 改成id查
      console.log('id,name===>', id, name)
      // console.log(id, name, path)
      switch (name) {
        case '预支预付':
        case '编辑-预支预付':
          this.clickTypeFun('/prePayment/getById', '预支预付', 'financialManage/advance/show.vue', id)
          break
        // 费用报销
        case `${this.$tree([], 'financialManage/expenseReim/index')}`:
        case `编辑-${this.$tree([], 'financialManage/expenseReim/index')}`:
          this.clickTypeFun('/reimbursement/getById', `${this.$tree([], 'financialManage/expenseReim/index')}`, 'financialManage/expenseReim/show.vue', id)
          break
        // 采购申请
        case `${this.$tree([], 'purchase/purchaseRequest/index')}`:
        case `编辑-${this.$tree([], 'purchase/purchaseRequest/index')}`:
          this.clickTypeFun('/purchaseRequisition/getById', `${this.$tree([], 'purchase/purchaseRequest/index')}`, 'purchase/purchaseRequest/show.vue', id)
          break
        // 收票
        case `${this.$tree([], 'financialManage/ticketReceiptRecord/index')}`:
        case `编辑-${this.$tree([], 'financialManage/ticketReceiptRecord/index')}`:
          this.clickTypeFun('/invoice/getById', `${this.$tree([], 'financialManage/ticketReceiptRecord/index')}`, 'financialManage/ticketReceiptRecord/viewCollection.vue', id)
          break
        // 开票
        case `${this.$tree([], 'financialManage/billingRecords/index')}`:
        case `编辑-${this.$tree([], 'financialManage/billingRecords/index')}`:
          this.clickTypeFun('/invoice/getById', `${this.$tree([], 'financialManage/billingRecords/index')}`, 'financialManage/billingRecords/viewBill.vue', id)
          break
        // 回款计划
        case `${this.$tree([], 'contractManage/paymentPlan/index')}`:
        case `编辑-${this.$tree([], 'contractManage/paymentPlan/index')}`:
          this.clickTypeFun('/payBack/getById', `${this.$tree([], 'contractManage/paymentPlan/index')}`, 'contractManage/paymentPlan/show.vue', id)
          break
        // 回款记录
        case `${this.$tree([], 'contractManage/paymentRecord/index')}`:
        case `编辑-${this.$tree([], 'contractManage/paymentRecord/index')}`:
          this.clickTypeFun('/payBack/getById', `${this.$tree([], 'contractManage/paymentRecord/index')}`, 'contractManage/paymentRecord/show.vue', id)
          break
        // 付款计划
        case `${this.$tree([], 'purchase/paymentSchedule/index')}`:
        case `编辑-${this.$tree([], 'purchase/paymentSchedule/index')}`:
          this.clickTypeFun('/payPlan/getById', `${this.$tree([], 'purchase/paymentSchedule/index')}`, 'purchase/paymentSchedule/paymentInfor.vue', id)
          break
        // 付款记录
        case `${this.$tree([], 'purchase/paymentRecords/index')}`:
        case `编辑-${this.$tree([], 'purchase/paymentRecords/index')}`:
          this.clickTypeFun('/payPlan/getById', `${this.$tree([], 'purchase/paymentRecords/index')}`, 'purchase/paymentRecords/recordInform.vue', id)
          break
        case `${this.$tree([], 'projectManage/humanCost/index')}`:
        case `编辑-${this.$tree([], 'projectManage/humanCost/index')}`:
          this.clickTypeFun('/humanCost/getById', `${this.$tree([], 'projectManage/humanCost/index')}`, 'projectManage/humanCost/detail.vue', id)
          break
        case `${this.$tree([], 'offices/courtesyApplication/index')}`:
        case `编辑-${this.$tree([], 'offices/courtesyApplication/index')}`:
          this.clickTypeFun('/festivalGift/getById', `${this.$tree([], 'offices/courtesyApplication/index')}`, 'offices/courtesyApplication/details.vue', id)
          break
        case `${this.$tree([], 'projectManage/fundCost/index')}`:
        case `编辑-${this.$tree([], 'projectManage/fundCost/index')}`:
          this.clickTypeFun('/fundCost/getById', `${this.$tree([], 'projectManage/fundCost/index')}`, 'projectManage/fundCost/detail.vue', id)
          break
        // 采购退款记录
        case `${this.$tree([], 'purchase/purchRefundRec/index')}`:
        case `编辑-${this.$tree([], 'purchase/purchRefundRec/index')}`:
          this.clickTypeFun('/payRefund/get', `${this.$tree([], 'purchase/purchRefundRec/index')}`, 'purchase/purchRefundRec/detail.vue', id)
          break
        // 跟进记录
        case `跟进记录`:
        case `编辑-跟进记录`:
          this.clickTypeFun('/opportunityLog/get', `跟进记录`, 'salesOpportunities/projectOpportunities/followDetails.vue', id)
          break
        // 合同增减
        case `${this.$tree([], 'contractManage/contractManagement/index')}`:
        case `编辑-${this.$tree([], 'contractManage/contractManagement/index')}`:
          this.clickTypeFun('/contract/supplement/getById', `${this.$tree([], 'contractManage/contractManagement/index')}`, 'contractManage/contractManagement/details.vue', id)
          break
        // 保证金
        case `${this.$tree([], 'contractManage/earnestMoney/index')}`:
        case `编辑-${this.$tree([], 'contractManage/earnestMoney/index')}`:
          this.clickTypeFun('/performance/getById', `${this.$tree([], 'contractManage/earnestMoney/index')}`, 'contractManage/earnestMoney/details.vue', id)
          break
        case `${this.$tree([], 'offices/operatingCosts/index')}`:
        case `编辑-${this.$tree([], 'offices/operatingCosts/index')}`:
          this.clickTypeFun('/operatingCosts/byId', `${this.$tree([], 'offices/operatingCosts/index')}`, 'offices/operatingCosts/details.vue', id)
          break
        default:
          break
      }
      // this.publicDrawerData = rowVal
      // // 展开抽屉
      // this.publicDrawer.title = name
      // this.publicDrawer.comName = path
      // this.publicDrawer.visible = true
      // if (name === '费用报销') {
      //   this.$get('/reimbursement/getById', {id: rowVal.id}).then(res => {
      //     let data = res.data.data
      //     this.$nextTick(() => {
      //       this.$refs.publicDrawerRef.setForm(data, null, [data.creator])
      //     })
      //   })
      // } else {
      //   this.$nextTick(() => {
      //     this.$refs.publicDrawerRef.setForm(rowVal, null, [rowVal.creator])
      //   })
      // }
    },
    publicDrawerClose () {
      this.$emit('invoiceListChange')
      this.publicDrawer = {
        title: '',
        visible: false,
        comName: ''
      }
    },
    projectChanges (value, name) {
      // this.publicDrawer.visible = false
      if (name === 'project') {
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
      if (name === 'salesOpportunities') this.openView(value, name)
    },
    openView (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.contractId)
      } else if (name === 'amortizePurchaseName') {
        this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.amortizePurchaseId)
      } else if (name === 'amortizeProjectName') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.amortizeProjectId)
      } else if (name === 'salesOpportunities') {
        this.$refs.clickViewRef.openView('salesOpportunities', rowVal, rowVal.opportunityId)
      }
    },
    openViews (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.id)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.id)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.id)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.id)
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    }
  }
}
</script>
<style scoped>
.pagination {
  text-align: center;
  margin: auto;
}

.timeLineDer {
  padding: 10px;
  /* height: 220px; */
  overflow: auto;
  overflow-x: hidden;
}

.timelineItem {
  margin-left: 20px;
}

.clickable {
  color: #1890ff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/common/TimeLine.vue